import DairyService, { IDairyBank, ILocationOptionData } from '@src/api/services/dairy';
import { useMutation, useQuery } from 'react-query';
import { onError } from '~/utils/helpers';

// Get Dairy Banks Query
const getDairyBanks = () => {
  return useQuery<IDairyBank, Error>('query-banks', DairyService.getDairyBanks, {
    cacheTime: 3000,
    enabled: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onError,
    retry: 1
  });
};

// Delete Dairy Bank Query
const deleteDairyBankById = (onSuccess: any) => {
  return useMutation(DairyService.deleteDairyBankById, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getDairyBankAccountById = (onSuccess: any) => {
  return useMutation(DairyService.getDairyBankAccountById, {
    onSuccess,
    onError,
    retry: 1
  });
};

// Create Bank Account Query
const createBankAccount = (onSuccess: any) => {
  return useMutation(DairyService.createBankAccount, {
    onSuccess,
    onError,
    retry: 1
  });
};

const editBankAccount = (onSuccess: any) => {
  return useMutation(DairyService.editBankAccount, {
    onSuccess,
    onError,
    retry: 1
  });
};

// Locations querys

const createLocation = (onSuccess: any) => {
  return useMutation(DairyService.createLocation, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getLocationOptionData = () => {
  return useQuery<ILocationOptionData, Error>(
    'query-location-option-data',
    DairyService.getLocationOptiondata,
    {
      retry: 1,
      refetchOnMount: false,
      refetchOnWindowFocus: false
    }
  );
};

const dairyLocationsList = (data?) => {
  return useQuery(
    'dairy-locations',
    ({ signal }) => DairyService.getDairyLocations(data, signal),
    {
      onError,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 1,
      select: (data) => {
        return data.data
      }
    }
  )
}

// District querys

const getDairyStates = () => {
  return useQuery('query-districts-states', DairyService.getDairyStates, {
    cacheTime: 3000,
    enabled: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onError,
    retry: 1
  });
};

const getDairyDistrictOptions = () => {
  return useQuery('query-districts-options', DairyService.getDistrictOptions, {
    enabled: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onError,
    retry: 1
  });
};

// Delete Dairy State Query
const deleteDairyStateById = (onSuccess: any) => {
  return useMutation(DairyService.deleteDairyStateById, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getDairyDistrictById = (onSuccess: any) => {
  return useMutation(DairyService.getDairyStateDistrictById, {
    onSuccess,
    onError,
    retry: 1
  });
};

const createDiaryState = (onSuccess: any) => {
  return useMutation(DairyService.createDairyState, {
    onSuccess,
    onError,
    retry: 1
  });
};

const createStateDistrict = (onSuccess: any) => {
  return useMutation(DairyService.createStateDistrict, {
    onSuccess,
    onError,
    retry: 1
  });
};

const editStateDistrict = (onSuccess: any) => {
  return useMutation(DairyService.editStateDistrict, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getMilkTypes = () => {
  return useQuery('query-milk-types', DairyService.getMilkTypes, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const editMilkType = (onSuccess: any) => {
  return useMutation(DairyService.editMilkType, {
    onSuccess,
    onError,
    retry: 1
  });
};

const createMilkType = (onSuccess: any) => {
  return useMutation(DairyService.createMilkType, {
    onSuccess,
    onError,
    retry: 1
  });
};

const deleteMilkType = (onSuccess: any) => {
  return useMutation(DairyService.deleteMilkType, {
    onSuccess,
    onError,
    retry: 1
  });
};

const updateMilkType = (onSuccess: any) => {
  return useMutation(DairyService.updateMilkType, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getHusbandryForms = () => {
  return useQuery('query-husbadry', DairyService.getHusbandryForms, {
    enabled: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const editHusbandryForm = (onSuccess: any) => {
  return useMutation(DairyService.editHusbandryForm, {
    onSuccess,
    onError,
    retry: 1
  });
};

const createHusbandryForm = (onSuccess: any) => {
  return useMutation(DairyService.createHusbandryForm, {
    onSuccess,
    onError,
    retry: 1
  });
};

const deleteHusbandryForm = (onSuccess: any) => {
  return useMutation(DairyService.deleteHusbandryForm, {
    onSuccess,
    onError,
    retry: 1
  });
};

const updateHusbandryForm = (onSuccess: any) => {
  return useMutation(DairyService.updateHusbandryForm, {
    onSuccess,
    onError,
    retry: 1
  });
};

const DairyQuery = {
  getDairyBanks,
  deleteDairyBankById,
  createBankAccount,
  editBankAccount,
  createLocation,
  getLocationOptionData,
  dairyLocationsList,
  getDairyBankAccountById,
  getDairyStates,
  deleteDairyStateById,
  createDiaryState,
  editStateDistrict,
  getDairyDistrictById,
  getDairyDistrictOptions,
  createStateDistrict,
  getMilkTypes,
  editMilkType,
  createMilkType,
  deleteMilkType,
  updateMilkType,
  createHusbandryForm,
  editHusbandryForm,
  updateHusbandryForm,
  deleteHusbandryForm,
  getHusbandryForms
};

export default DairyQuery;
